import Vue from "vue";
import VueRouter from "vue-router";
import Error404 from "@/views/Error404.vue";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: { name: "report" }
  },
  {
    path: "/report",
    name: "report",
    component: () =>
      import(/* webpackChunkName: "report" */ "@/views/Report.vue")
  },
  {
    path: "/schnellcheck",
    name: "benchmarking",
    component: () =>
      import(/* webpackChunkName: "benchmarking" */ "@/views/Benchmarking.vue")
  },
  {
    path: "/vergleich",
    name: "comparison",
    component: () =>
      import(/* webpackChunkName: "comparison" */ "@/views/Comparison.vue")
  },
  {
    path: "/methodologie",
    name: "methodology",
    component: () =>
      import(/* webpackChunkName: "methodology" */ "@/views/Methodology.vue")
  },
  {
    path: "/stichprobe",
    name: "sample",
    component: () =>
      import(/* webpackChunkName: "sample" */ "@/views/Sample.vue")
  },
  {
    path: "/annex",
    name: "annex",
    component: () => import(/* webpackChunkName: "annex" */ "@/views/Annex.vue")
  },
  {
    path: "*",
    name: "Error404",
    component: Error404
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  store.dispatch("setIsLoading", true);
  next();
});

router.afterEach(() => {
  store.dispatch("setIsLoading", false);
});

export default router;
